
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OccasionData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OccasionTopicMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"occasionData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"liveStreamUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"venue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"liveVideoIframe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occasionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMapPreviewRequired"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OccasionFeaturedGuest"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OccasionTime"},"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./OccasionTime.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./OccasionFeaturedGuest.fragment.graphql").definitions));


    module.exports = doc
  
